
import { 
    SEND_FEEDBACK,
    SEND_FEEDBACK_SUCCESS,
    SEND_FEEDBACK_FAIL, 
    SEND_FEEDBACK_RESET,
} from "../actions/sendFeedbackAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const sendFeedbackReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_FEEDBACK:
            return {
                ...state,
                apiState: "loading",
            };
        case SEND_FEEDBACK_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case SEND_FEEDBACK_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case SEND_FEEDBACK_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default sendFeedbackReducer;
